import { types, applySnapshot } from "mobx-state-tree";
import { Framework } from "@flint/framework";

const AddSubscriptionModel = types
  .model("AddSubscriptionModel", {
    res: types.string,
  })
  .actions((self) => ({
    fetch() {
      Framework.sendEvent("ADDING_SUBSCRIPTION_DATA");
    },
    set(response) {
      let status = response.status;
      let data;
      if (status === 201) {
        data = `The subscription has been added successfully.`;
      } if(status === 200) {
        data = `A subscription with this SKU already exists. Please try with other SKU.`
      } else {
        data = status;
      }
      applySnapshot(self, {
        res: data,
      });
    },
    reset() {
      applySnapshot(self, {
        res:"Oops...Something went wrong. Please try again.",
      });
    },
  }));

export default AddSubscriptionModel;
